import CreateObjectButton from './CreateObjectButton';
import { CreateObjectDropdownBehavior } from './CreateObjectDropdown';
import { useIsCrmi0001Variant } from '../../experiments/hooks/useIsCrmi0001Variant';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreateObjectWrapper = props => {
  const {
    isInExperiment
  } = useIsCrmi0001Variant();
  return isInExperiment ? /*#__PURE__*/_jsx(CreateObjectDropdownBehavior, Object.assign({}, props)) : /*#__PURE__*/_jsx(CreateObjectButton, Object.assign({}, props));
};